import { Component, Fragment } from 'react'

import emitter from 'garden/src/js/utils/emitter'

import fetch from 'scripts/utils/fetch'

import Loader from 'reactSite/Loader'
import { Collapse } from 'reactSite/Collapse'

import LastMile from './components/LastMile'
import OrderTitle from './components/Order/Title'
import OrderContent from './components/Order/Content'
import PageTitle from './components/PageTitle'

const DEFAULTS = {
  endpoints: {
    orders: '/user-sale-orders',
    ordersToPay: '/user-pending-payment-sale-orders'
  },
  messages: {
    error: {
      title: 'Ops! Ocorreu o seguinte erro:'
    }
  }
}

const AVAILABLE_PICKUP_STATUS = 'DISPONIVEL PARA RETIRADA'

class MyOrders extends Component {
  constructor (props) {
    super(props)

    this.fetch = fetch
    this.fiscalId = this.props.fiscalId
    this.ordersUrl = this.fiscalId ? `${DEFAULTS.endpoints.orders}?fiscalId=${this.fiscalId}` : `${DEFAULTS.endpoints.orders}`
    this.ordersToPayUrl = this.fiscalId ? `${DEFAULTS.endpoints.ordersToPay}?fiscalId=${this.fiscalId}` : `${DEFAULTS.endpoints.ordersToPay}`

    this.state = {
      orders: [],
      ordersToPay: [],
      loading: true
    }

    this.getOrders = this.getOrders.bind(this)

    Promise.all([
      this.getOrders(),
      this.getOrdersToPay()
    ])
      .then(([dataOrders, dataOrdersToPay]) => {
        this.onGetSuccess(dataOrders, dataOrdersToPay)
      })
  }

  emitErrorsMessage (error) {
    emitter.emit('stickyFeedback:error', {
      title: this.messages.error.title,
      content: error
    })
  }

  getOrders () {
    return this.fetch(this.ordersUrl)
      .then((response) => {
        if (response.status !== 200) {
          return this.onGetFailure()
        }

        return response.json()
      })
  }

  getOrdersToPay () {
    return this.fetch(this.ordersToPayUrl)
      .then((response) => {
        if (response.status !== 200) {
          return this.onGetFailure()
        }

        return response.json()
      })
  }

  onGetSuccess (dataOrders, dataOrdersToPay) {
    this.setState({
      orders: dataOrders,
      ordersToPay: dataOrdersToPay,
      loading: false
    })
  }

  onGetFailure () {
    throw new Error('Bad request')
  }

  render () {
    const { ordersToPay, orders, loading } = this.state
    let checkIsOpen = (order) => this.props.saleOrderId === order.id

    if (this.props.errors) {
      this.emitErrorsMessage(this.props.errors)
    }

    const allOrders = [...orders, ...ordersToPay]
    const hasOrderWithId = allOrders.some((order) => order.id === this.props.saleOrderId)

    if (this.props.saleOrderId && allOrders.length > 0 && !hasOrderWithId) {
      checkIsOpen = (_, index) => index === 0
      emitter.emit('stickyFeedback:error', {
        title: 'Ops! ocorreu o seguinte erro:',
        content: 'Pedido não encontrado. Verifique se o login realizado no aplicativo corresponte ao CPF informado ao assessor.'
      })
    }

    if (loading) {
      return <Loader />
    }

    if (!orders.length && !ordersToPay.length) {
      return (
        <div className="error-wrapper color-default">
          <span>Você ainda não fez nenhum pedido, que tal aproveitar?</span>
        </div>
      )
    }

    return (
      <Fragment>
        {ordersToPay.length > 0 &&
          <div className="orders-to-pay">
            <PageTitle className="margin-bottom">Finalizar pedidos de Loja</PageTitle>
            {ordersToPay.map((order, index) => (
              <Collapse
                className="order-react-collapse"
                isOpen={checkIsOpen(order, index)}
                key={index}
                title={<OrderTitle fiscalId={this.fiscalId} hasOrderToPay={1} {...order} />}
                content={<OrderContent isOpen={checkIsOpen(order, index)} {...order} />}
              />)
            )}
          </div>
        }
        {orders.length > 0 &&
          <Fragment>
            <PageTitle>Pedidos</PageTitle>
            <div className="row">
              <div className="col-xs-12">
                {orders.map((order, index) => {
                  const hasOrderToPickUp = order.status === AVAILABLE_PICKUP_STATUS

                  return (
                    <Collapse
                      isOpen={checkIsOpen(order, index)}
                      className="order-react-collapse"
                      key={index}
                      title={<OrderTitle serviceCount={order.services?.items.length} hasOrderToPickUp={hasOrderToPickUp} {...order} />}
                      content={<OrderContent isOpen={checkIsOpen(order, index)} hasOrderToPickUp={hasOrderToPickUp} {...order} />}
                    />
                  )
                })}
              </div>
            </div>
          </Fragment>
        }
        <LastMile />
      </Fragment>
    )
  }
}

export default MyOrders
